"use strict";

var _objectWithoutProperties = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _defineProperty = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = SwipeOver;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _ = _interopRequireDefault(require("../"));

var _gsap = _interopRequireDefault(require("gsap"));

var _jsxFileName = "/Users/tyler/Documents/GitHub/gatsby-plugins/transition-link/gatsby-plugin-transition-link/src/AniLink/Swipe.js";
var boxShadow = '0 0 100px 10px rgba(0, 0, 0, 0.12941176470588237)';

var swipeTopDirection = function swipeTopDirection(direction, reverse) {
  var polarityPos = reverse ? '-' : '+';
  var polarityNeg = reverse ? '+' : '-';

  switch (direction) {
    case 'down':
      return {
        y: "".concat(polarityPos, "=100vh"),
        ease: "power1.easeIn"
      };

    case 'up':
      return {
        y: "".concat(polarityNeg, "=100vh"),
        ease: "power1.easeIn"
      };

    case 'left':
      return {
        x: "".concat(polarityNeg, "=100%"),
        ease: "power1.easeIn"
      };

    default:
      return {
        x: "".concat(polarityPos, "=100%"),
        ease: "power1.easeIn"
      };
  }
};

var swipeBottomDirection = function swipeBottomDirection(direction) {
  var reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 40;
  var polarityPos = reverse ? '-' : '';
  var polarityNeg = reverse ? '' : '-';

  switch (direction) {
    case 'down':
      return {
        y: "".concat(polarityNeg).concat(offset, "vh"),
        ease: "power1.easeIn"
      };

    case 'up':
      return {
        y: "".concat(polarityPos).concat(offset, "vh"),
        ease: "power1.easeIn"
      };

    case 'left':
      return {
        x: "".concat(polarityPos).concat(offset, "%"),
        ease: "power1.easeIn"
      };

    default:
      return {
        x: "".concat(polarityNeg).concat(offset, "%"),
        ease: "power1.easeIn"
      };
  }
};

var swipe = function swipe(_ref) {
  var node = _ref.node,
      exit = _ref.exit,
      direction = _ref.direction,
      top = _ref.top,
      triggerName = _ref.triggerName,
      entryOffset = _ref.entryOffset;
  var scrollTop = document.scrollingElement && document.scrollingElement.scrollTop || document.body.scrollTop || window.pageYOffset;

  if (triggerName === 'entry' && top === 'entry') {
    return _gsap.default.timeline().set(node, {
      boxShadow: boxShadow,
      overflowY: 'hidden',
      height: '100vh',
      scrollTop: scrollTop
    }).from(node, _objectSpread(_objectSpread({}, swipeTopDirection(direction, true)), {}, {
      duration: exit.length
    })).set(node, {
      overflowY: 'initial'
    });
  } else if (triggerName === 'entry') {
    return _gsap.default.timeline().from(node, _objectSpread(_objectSpread({}, swipeBottomDirection(direction, false, entryOffset)), {}, {
      duration: exit.length
    }));
  } else if (triggerName === 'exit' && top === 'exit') {
    return _gsap.default.timeline().set(node, {
      boxShadow: boxShadow,
      overflowY: 'hidden',
      height: '100vh',
      scrollTop: scrollTop
    }).to(node, _objectSpread(_objectSpread({}, swipeTopDirection(direction)), {}, {
      duration: exit.length
    })).set(node, {
      overflowY: 'initial'
    });
  } else {
    return _gsap.default.timeline().set(node, {
      boxShadow: boxShadow,
      overflowY: 'hidden',
      height: '100vh',
      scrollTop: scrollTop
    }).to(node, _objectSpread(_objectSpread({}, swipeBottomDirection(direction, true, entryOffset)), {}, {
      duration: exit.length
    })).set(node, {
      overflowY: 'initial'
    });
  }
};

function SwipeOver(_ref2) {
  var exit = _ref2.exit,
      entry = _ref2.entry,
      removedProp = _ref2.swipe,
      _ref2$entryOffset = _ref2.entryOffset,
      entryOffset = _ref2$entryOffset === void 0 ? 40 : _ref2$entryOffset,
      props = _objectWithoutProperties(_ref2, ["exit", "entry", "swipe", "entryOffset"]);

  var top = props.top || 'exit';
  var exitLength = props.duration || 0.7;
  var entryLength = exitLength / 3.5;
  var entryZ = top === 'entry' ? 1 : 0;
  var exitZ = top === 'exit' ? 1 : 0;
  return /*#__PURE__*/_react.default.createElement(_.default, (0, _extends2.default)({
    exit: {
      length: exitLength,
      trigger: function trigger(_ref3) {
        var node = _ref3.node,
            exit = _ref3.exit;
        return swipe({
          node: node,
          exit: exit,
          direction: props.direction,
          top: top,
          entryOffset: entryOffset,
          triggerName: 'exit'
        });
      },
      zIndex: exitZ
    },
    entry: {
      length: entryLength,
      trigger: function trigger(_ref4) {
        var node = _ref4.node,
            exit = _ref4.exit;
        return swipe({
          node: node,
          exit: exit,
          direction: props.direction,
          top: top,
          entryOffset: entryOffset,
          triggerName: 'entry'
        });
      },
      zIndex: entryZ
    }
  }, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 106,
      columnNumber: 3
    }
  }), props.children);
}